"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeUserId = void 0;
/**
 * For now, users identified in attestation storage (data node) with their address.
 */
const makeUserId = (key) => key.getEthAddress();
exports.makeUserId = makeUserId;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFrZS11c2VyLWlkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2F0dGVzdGF0aW9uL21ha2UtdXNlci1pZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQTs7R0FFRztBQUNJLE1BQU0sVUFBVSxHQUFHLENBQUMsR0FBYyxFQUFFLEVBQUUsQ0FBQyxHQUFHLENBQUMsYUFBYSxFQUFFLENBQUE7QUFBcEQsUUFBQSxVQUFVLGNBQTBDIn0=